export class chatToAdminList {
    constructor(adminListObj) {
        this.adminID                 = adminListObj.ID;        	
        this.adminName		         = adminListObj.Username;
    }
}